import { render, staticRenderFns } from "./ErrorLabel.vue?vue&type=template&id=1c1eb8ce&scoped=true&"
import script from "./ErrorLabel.vue?vue&type=script&lang=js&"
export * from "./ErrorLabel.vue?vue&type=script&lang=js&"
import style0 from "./ErrorLabel.vue?vue&type=style&index=0&id=1c1eb8ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1eb8ce",
  null
  
)

export default component.exports